module.exports = __webpack_public_path__ + "static/img/official.b46f97a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/official.jpg
// module id = tJA5
// module chunks = 1